import { ChallengeReceivedPayload } from "@/types/battle"
import {
  FREE_BATTLE_DESCRIPTION,
  FREE_BATTLE_LABEL,
  formatChallengeModeLabel,
} from "@/constants/battleLabels"
import { RANK_NAMES } from "@/constants/guardians"
import { RADAR_ENERGY_COST } from "@/constants/game.constants"

type Props = {
  challenge: ChallengeReceivedPayload | null
  accepting?: boolean
  onAccept: () => void
  onDecline: () => void
}

export default function IncomingChallengeModal({
  challenge,
  accepting = false,
  onAccept,
  onDecline,
}: Props) {
  if (!challenge) return null

  const isRank = challenge.searchMode === "RANK" && challenge.colorRank

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
      <div className="w-full max-w-sm rounded-2xl border border-guardians-accent/30 bg-[#1a1a2e] p-6 shadow-xl">
        <h2 className="text-center text-lg font-bold text-white">Вызов на бой!</h2>
        <p className="mt-1 text-center text-xs text-guardians-muted">
          Соперник скрыт до начала боя
        </p>
        <div className="mt-4 rounded-xl border border-white/10 bg-white/5 p-4 text-center">
          <p className="text-sm font-medium text-guardians-accent">
            {formatChallengeModeLabel(challenge.searchMode, challenge.colorRank)}
          </p>
          {isRank && challenge.colorRank ? (
            <p className="mt-2 text-xs text-guardians-muted">
              Только карты ранга «{RANK_NAMES[challenge.colorRank]}»
            </p>
          ) : (
            <p className="mt-2 text-xs text-guardians-muted">{FREE_BATTLE_DESCRIPTION}</p>
          )}
          <p className="mt-3 text-[10px] text-guardians-muted">
            Энергия {RADAR_ENERGY_COST} · режим {isRank ? "ранг" : FREE_BATTLE_LABEL}
          </p>
        </div>
        <div className="mt-6 flex gap-2">
          <button
            type="button"
            onClick={onDecline}
            disabled={accepting}
            className="flex-1 rounded-xl border border-white/20 py-2.5 text-sm"
          >
            Отклонить
          </button>
          <button
            type="button"
            onClick={onAccept}
            disabled={accepting}
            className="flex-1 rounded-xl bg-guardians-accent py-2.5 text-sm font-medium text-guardians-bg disabled:opacity-60"
          >
            {accepting ? "…" : "Принять"}
          </button>
        </div>
      </div>
    </div>
  )
}
